import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceHelperService {
  public maintenanceStartTimeSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public verify(response): void {
    if (response.headers) {
      const maintenanceStart = response.headers.get('Maintenance-Time');
      if (maintenanceStart) this.maintenanceStartTimeSubject.next(maintenanceStart);
    }
  }
  public checkIfUnderMaintenance(response): boolean {
    const maintenanceStart = response.headers.get('Maintenance-Time');
    const duration = moment.duration(moment(maintenanceStart).diff(moment()));
    if (duration.asMinutes() < 0) {
      window.location.href = 'https://rize.azzly.com/maintenance/';
      return true;
    }
    return false;
  }
}
